__turbopack_context__.v({
  "heldTask": "ZapPauseToggle-module__Rqq4iG__heldTask",
  "zapPauseToggle": "ZapPauseToggle-module__Rqq4iG__zapPauseToggle",
});
